import { Row, Col, Form, Button, Spinner } from "react-bootstrap";
import { useLayouts, useEventDivisions } from "../util/db";
import { useState } from "react";
import { updateEventDivisionLayout } from "../util/db";

function EventManageLayoutsChange({ eventId }) {
  const [editStates, setEditStates] = useState({});
  const [submittingStates, setSubmittingStates] = useState({});
  const [submittedStates, setSubmittedStates] = useState({});
  const [layoutStates, setLayoutStates] = useState({});

  const {
    data: layouts,
    // status: layoutsStatus
  } = useLayouts();
  const {
    data: divisions,
    // status: divisionsStatus
  } = useEventDivisions(eventId);

  const handleLayoutChange = (divisionId, layoutId) => {
    setLayoutStates((prev) => ({ ...prev, [divisionId]: layoutId }));
    setEditStates((prev) => ({ ...prev, [divisionId]: true }));
    setSubmittedStates((prev) => ({ ...prev, [divisionId]: false }));
  };

  const handleSubmit = async (e, division) => {
    e.preventDefault();
    const divisionId = division.event_divisions_id;
    const layoutId = layoutStates[divisionId] || division.layout_id;

    setSubmittingStates((prev) => ({ ...prev, [divisionId]: true }));
    await updateEventDivisionLayout(divisionId, layoutId);
    setSubmittedStates((prev) => ({ ...prev, [divisionId]: true }));
    setSubmittingStates((prev) => ({ ...prev, [divisionId]: false }));
    setEditStates((prev) => ({ ...prev, [divisionId]: false }));
  };

  return (
    <>
      {divisions?.map((division, index) => (
        <Form key={index} onSubmit={(e) => handleSubmit(e, division)}>
          <Form.Group
            className="mb-3"
            controlId={`layout-${division.event_divisions_id}`}
          >
            <Row className="align-items-center">
              <Col xs={12} sm={3} md={3}>
                <Form.Label style={{ color: "#2D083F", marginBottom: "0" }}>
                  {division.divisions.name}
                </Form.Label>
              </Col>
              <Col xs={8} sm={6} md={6}>
                <Form.Control
                  as="select"
                  style={{
                    color: "#2D083F",
                    height: "38px",
                    lineHeight: "1.5",
                    padding: "6px 12px",
                    fontSize: "1rem",
                  }}
                  required
                  value={
                    layoutStates[division.event_divisions_id] ||
                    division.layout_id
                  }
                  onChange={(e) =>
                    handleLayoutChange(
                      division.event_divisions_id,
                      e.target.value
                    )
                  }
                >
                  {layouts?.map((layout, layoutIndex) => (
                    <option key={layoutIndex} value={layout.layout_id}>
                      {layout.layout_name}
                    </option>
                  ))}
                </Form.Control>
              </Col>
              <Col xs={4} sm={3} md={3}>
                <Button
                  type="submit"
                  disabled={
                    !editStates[division.event_divisions_id] ||
                    submittingStates[division.event_divisions_id]
                  }
                  size="sm"
                  className="w-100"
                >
                  {submittedStates[division.event_divisions_id] ? (
                    "✔"
                  ) : submittingStates[division.event_divisions_id] ? (
                    <Spinner animation="border" />
                  ) : (
                    "Update"
                  )}
                </Button>
              </Col>
            </Row>
          </Form.Group>
        </Form>
      ))}
    </>
  );
}

export default EventManageLayoutsChange;
